module.exports = __webpack_public_path__ + "static/media/promotion_from_35_to_39.c725e313.webp";